// Copyright (c) 2023-present VexFlow contributors: https://github.com/vexflow/vexflow/graphs/contributors
// @author: Taehoon Moon 2014
// MIT License
import { Clef } from './clef';
import { Note } from './note';
import { Category } from './typeguard';
/** ClefNote implements clef annotations in measures. */
export class ClefNote extends Note {
    static get CATEGORY() {
        return Category.ClefNote;
    }
    constructor(type, size = 'default', annotation) {
        super({ duration: 'b' });
        this.setType(type, size, annotation);
        this.ignoreTicks = true;
    }
    /** Set clef type, size and annotation. */
    setType(type, size, annotation) {
        this.clef = new Clef(type, size, annotation);
        this.setWidth(this.clef.getWidth());
        return this;
    }
    /** Get associated clef. */
    getClef() {
        return this.clef;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    /** Render clef note. */
    draw() {
        const stave = this.checkStave();
        const ctx = this.checkContext();
        this.setRendered();
        this.clef.setX(this.getAbsoluteX());
        this.clef.setY(stave.getYForLine(this.clef.line));
        this.clef.renderText(ctx, 0, 0);
    }
    getBoundingBox() {
        return this.clef.getBoundingBox();
    }
}
